import { useSelector } from "react-redux";

import { RootState } from "../redux/rootReducer";
import { WorkBackend } from "../redux/workBackendSlice";

const useWorkBackend = (): WorkBackend => {
  const workBackend = useSelector((state: RootState) => state.workBackend);
  return workBackend;
}

export default useWorkBackend;
